class Accordion {
  constructor(selector = '.faq-item') {
    this.selector = selector;
    this.init();
  }

  init() {
    $(document).ready(() => {
      this.bindEvents();
    });
  }

  bindEvents() {
    $('.faq-question').click((event) => {
      this.handleClick(event);
    });
  }

  handleClick(event) {
    const $item = $(event.currentTarget).parent(this.selector);
    const isActive = $item.hasClass('active');
    
    // Close all items
    $(this.selector).removeClass('active');
    
    // If this item wasn't active, open it
    if (!isActive) {
      $item.addClass('active');
    }
  }
}

// Usage:
export default Accordion